import { render, staticRenderFns } from "./ProctorMonitor.vue?vue&type=template&id=596349a7&scoped=true&"
import script from "./ProctorMonitor.vue?vue&type=script&lang=js&"
export * from "./ProctorMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ProctorMonitor.vue?vue&type=style&index=0&id=596349a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596349a7",
  null
  
)

export default component.exports